
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.md?watch=parent';
    export const demoIndex = {
  ids: ["fishbonediagram-demo-common","fishbonediagram-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__FishboneDiagram" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FishboneDiagram/index.md?type=demo')
};